// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { Attention } from './attention.zod.ts';
import { IndustrySpread } from './industrySpread.zod.ts';
import { MyIdeas } from './myIdeas.zod.ts';

export const DashboardOut = zod.object({
  "attention": zod.union([Attention,zod.null()]),
  "industries": IndustrySpread,
  "mine": MyIdeas
});

export type DashboardOut = zod.input<typeof DashboardOut>;
export type DashboardOutOutput = zod.output<typeof DashboardOut>;
